import Dexie from "dexie";
import relationships from "dexie-relationships";
import BaseRepository from "./base-repository";
import TransactionManager from "./transaction-manager";
import BaseStorage from "./base-storage";
import MemoryCache from "./memory-cache";
import SeasonRepository from "./season-repository";
import PlayRepository from "./play-repository";

const footballStorage = new Dexie("prestostats", {
    addons: [relationships]
});

footballStorage.version(1).stores({
    application: "&id",
    sync: "&id, eventId -> event.id",
    play: "&id, driveId -> drive.id, gameId -> game.id",
    fragment:
        "&id, playId -> play.id, associatedState, &[playId+associatedState+associatedHistoryIndex]",
    team: "&id, &teamId, seasonId",
    player: "&id, &playerId, teamId -> team.id, &[playerId+teamId]",
    drive: "&id, gameId -> game.id, index",
    game: "&id, &eventId",
    context: "&id, gameId -> game.id",
    season: "&id, &seasonId",
    event: "&id, &eventId, sportId, [sportId+statusCode]",
    stats: "&id, gameId -> game.id, playId -> play.id, teamId -> team.id, playerId -> player.id, driveId -> drive.id, [playerId+fragmentId], [fragmentId+category], [gameId+driveId]",
    match: "&id, eventId -> event.id, gameId -> game.id",
    stream: "&id, eventId -> event.id"
});

export const applicationRepository = new BaseRepository(
    footballStorage.application
);
export const syncRepository = new BaseRepository(footballStorage.sync);
export const playRepository = new PlayRepository(footballStorage.play);
export const fragmentRepository = new BaseRepository(footballStorage.fragment);
export const teamRepository = new BaseRepository(
    footballStorage.team,
    new MemoryCache()
);
export const playerRepository = new BaseRepository(
    footballStorage.player,
    new MemoryCache()
);
export const driveRepository = new BaseRepository(footballStorage.drive);
export const gameRepository = new BaseRepository(footballStorage.game);
export const contextRepository = new BaseRepository(footballStorage.context);
export const seasonRepository = new SeasonRepository(footballStorage.season);
export const eventRepository = new BaseRepository(footballStorage.event);
export const statsRepository = new BaseRepository(footballStorage.stats);
export const matchRepository = new BaseRepository(footballStorage.match);
export const streamRepository = new BaseRepository(footballStorage.stream);
export const storage = new BaseStorage(footballStorage);
export const transactionManager = new TransactionManager(footballStorage);
